module.exports = __webpack_public_path__ + "static/storage-base-5-f11abb0a739befae0146d8d165464960.webp";